import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Row, Col, Spin, Icon, Button, Select } from 'antd';
import {
  ssrHandler,
  sortingChange,
  fetchActiveReportsMetaData,
  fetchShippingLabels,
  fetchPaginatedShippingLabels,
  resetShippingLabels
} from '../actions/sessionActions';

const { Option } = Select;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const columns = [
  {
    title: 'Enterprise',
    key: 'enterprise_user__name',
    width: 20
  },
  {
    title: 'Label Size',
    key: 'enterprise_user__name',
    width: 15
  },
  {
    title: 'Courier Partner',
    key: 'courier_partner__name',
    width: 20
  },
  {
    title: 'Account Name',
    key: 'account_type__account_name',
    width: 20
  },
  {
    title: 'File Upload',
    key: 'file_upload',
    width: 25
  }
];

export class ShippingLabelList extends Component {
  static async fetchData({ dispatch }, match, route) {
    await dispatch(ssrHandler(route.path));
  }
  constructor() {
    super();
    this.state = { enterpriseId: undefined, enterprise: null };
  }

  componentDidMount() {
    this.props.fetchActiveReportsMetaData('enterprise');
    // this.props.fetchShippingLabels();
  }

  componentWillUnmount = () => {
    this.props.resetShippingLabels();
  };

  pagination = () => {
    const query = {};
    if (this.state.enterpriseId) {
      query.enterprise = this.state.enterpriseId;
    }
    this.props.fetchPaginatedShippingLabels(query);
  };

  reset = () => {
    this.setState({ enterpriseId: null, enterprise: null });
    this.props.resetShippingLabels();
    // this.props.fetchShippingLabels();
  };

  handleChange = index => {
    const { metadata } = this.props;
    const enterprise = metadata.enterprise.list[index];
    this.setState({ enterpriseId: enterprise.id, enterprise });
  };

  handleSearch = () => {
    const { id, key } = this.state.enterprise;
    this.props.fetchShippingLabels({ id, key });
  };

  render() {
    const { shippingLabels, metadata } = this.props;
    return (
      <div>
        <Row className="margin-bottom-10 view-header">
          <Col span={20}>
            <Select
              showSearch
              style={{ width: '100%' }}
              placeholder="Select enterprise"
              optionFilterProp="children"
              value={
                this.state.enterprise ? this.state.enterprise.name : undefined
              }
              onChange={this.handleChange}
              allowClear={true}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {metadata.enterprise.list.map((enterprise, i) => (
                <Option key={i} value={i}>
                  {enterprise.name}
                </Option>
              ))}
            </Select>
          </Col>
          <Col span={4} className="text-right">
            <Button
              className="ant-btn ant-btn-primary margin-right-20"
              disabled={!this.state.enterpriseId}
              onClick={this.handleSearch}
            >
              Search
            </Button>
            <Button className="ant-btn ant-btn-primary" onClick={this.reset}>
              Reset
            </Button>
          </Col>
        </Row>
        <Row>
          <Col span={24} className="margin-bottom-10">
            {shippingLabels.isFetching ? (
              <Spin indicator={antIcon} />
            ) : (
              <Fragment>
                {shippingLabels.list.length <= 0 ? (
                  <div>&nbsp; No Data</div>
                ) : (
                  <Fragment>
                    <table className={`ant-table ant-table-small width-100pt`}>
                      <thead className="ant-table-thead">
                        <tr>
                          {columns.map((item, i) => (
                            <th
                              className="padding-8"
                              key={i}
                              width={`${item.width}%`}
                            >
                              {item.title}
                              {/* <Icon type="sort-ascending" /> */}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="ant-table-tbody">
                        {shippingLabels.list.map((item, i) => (
                          <tr key={i}>
                            <td className="padding-8">
                              <NavLink
                                to={`/shipping-labels/edit?enterprise=${item.enterprise_user__id}`}
                                target="_blank"
                              >
                                {item.enterprise_user__name}
                              </NavLink>
                            </td>
                            <td className="padding-8">
                              <NavLink
                                to={`/shipping-labels/edit?enterprise=${item.enterprise_user__id}`}
                                target="_blank"
                              >
                                {item.label_size}
                              </NavLink>
                            </td>
                            <td className="padding-8">
                              <NavLink
                                to={`/shipping-labels/edit?enterprise=${item.enterprise_user__id}&cp_id=${item.courier_partner__id}`}
                                target="_blank"
                              >
                                {item.courier_partner__name}
                              </NavLink>
                            </td>
                            <td className="padding-8">
                              <NavLink
                                to={`/shipping-labels/edit?enterprise=${item.enterprise_user__id}&cp_id=${item.courier_partner__id}&account_id=${item.account_type__id}`}
                              >
                                {item.account_type__account_name}
                              </NavLink>
                            </td>
                            <td className="padding-8">
                              <a
                                href={`https://pyck-res-bucket.s3.amazonaws.com/${item.file_upload}`}
                              >
                                {item.file_upload}
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Fragment>
                )}
              </Fragment>
            )}
          </Col>
          {shippingLabels.count > shippingLabels.list.length &&
          shippingLabels.list.length > 0 ? (
            <Col span={24} className="text-center">
              <Button
                type="primary"
                onClick={this.pagination}
                loading={shippingLabels.isPaginationFetching}
                disabled={shippingLabels.isPaginationFetching}
              >
                Load More
              </Button>
            </Col>
          ) : null}
        </Row>
      </div>
    );
  }
}

ShippingLabelList.propTypes = {
  shippingLabels: PropTypes.object,
  metadata: PropTypes.object,
  config: PropTypes.object,
  match: PropTypes.object,
  fetchActiveReportsMetaData: PropTypes.func,
  sortingChange: PropTypes.func,
  fetchShippingLabels: PropTypes.func,
  fetchPaginatedShippingLabels: PropTypes.func,
  resetShippingLabels: PropTypes.func
};

ShippingLabelList.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  config: state.session.config,
  shippingLabels: state.session.shippingLabels,
  metadata: state.session.metadata
});

const mapDispatchToProps = dispatch => ({
  sortingChange: query => dispatch(sortingChange(query)),
  fetchActiveReportsMetaData: query =>
    dispatch(fetchActiveReportsMetaData(query)),
  fetchShippingLabels: query => dispatch(fetchShippingLabels(query)),
  fetchPaginatedShippingLabels: query =>
    dispatch(fetchPaginatedShippingLabels(query)),
  resetShippingLabels: () => dispatch(resetShippingLabels())
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShippingLabelList)
);
